import { render } from "./MdNavigationDivider.vue?vue&type=template&id=6e545958&scoped=true&ts=true"
import script from "./MdNavigationDivider.vue?vue&type=script&lang=ts"
export * from "./MdNavigationDivider.vue?vue&type=script&lang=ts"

import "./MdNavigationDivider.vue?vue&type=style&index=0&id=6e545958&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e545958"]])

export default __exports__